import {createAction} from 'typesafe-actions';

import {DiscussionComment, Ref as DiscussionCommentRef} from './types';

export const updateDiscussionComment = createAction(
  '@discussionComment/updateDiscussionComment',
  action => (ref: DiscussionCommentRef, updatedComment: DiscussionComment) =>
    action({ref, updatedComment})
);
